
import Screen_Model from '@/nextts/model/Screen_Model';

//기본 데이터 속성
class Content_Model {

    idx:string|null             = null;     //오리지널 컨텐츠 idx
    category_idx:Number|null    = null;
    content_type:Number|null    = 0;        //0:content, 1:assets
    
    //사용자가 오리지널 컨텐츠를 복제하여 저장할 때 사용함.
    content_mode:Number|null    = 0;        //0:admin, 1:user
    mcon_idx:string|null        = null;
    localid:String|null         = null;     //저장할 사용자의 idx content_mode가 1일경우만 사용
    parent_localid:String|null  = null;     //저장할 사용자의 idx content_mode가 1일경우만 사용

    name:string     = "";
    
    //컨텐츠 사이즈 정보
    width:Number    = 0;
    height:Number   = 0;

    //스크린 리스트 정보
    screen_list:Array<Screen_Model>;

    //API로 조회된 데이터 저장소
    static apiData: Map<string, any> = new Map();

    //페이지별 dataformat 저장소 (mask 등 메타정보 조회용)
    static apiFormat: Map<string, any[]> = new Map();

    //마스크 패턴 적용: '*' 위치만 가림, 그 외는 데이터 글자 노출
    //출력 시 한글과 정렬 자연스럽게 맞추기 위해 전각 별표(＊)로 표시
    static applyMask(value: any, mask: string): string {
        if (value === null || value === undefined) return '';
        const v = String(value);
        if (!mask) return v;
        let result = '';
        for (let i = 0; i < v.length; i++) {
            if (i < mask.length && mask[i] === '*') {
                result += '＊';
            } else {
                result += v[i];
            }
        }
        return result;
    }

    //페이지명 + apiarray(또는 필드명)로 mask 패턴 조회
    //apiarray가 "[0][이름]" / "0.이름" / "이름" 형태 모두 처리
    static getMaskForField(pageName: string, apiarrayOrField: string): string {
        if (!pageName || !apiarrayOrField) return '';
        const format = Content_Model.apiFormat.get(pageName);
        if (!format || !Array.isArray(format)) return '';

        let fieldName = String(apiarrayOrField);
        //마지막 [...] 추출 ([0][이름] → 이름)
        const bracketMatch = fieldName.match(/\[([^\[\]]+)\]\s*$/);
        if (bracketMatch) {
            fieldName = bracketMatch[1];
        } else if (fieldName.indexOf('.') >= 0) {
            //dot 표기 (0.이름 → 이름)
            fieldName = fieldName.split('.').pop() || fieldName;
        }

        const f = format.find((x: any) => x && x.name === fieldName);
        return (f && f.mask) ? String(f.mask) : '';
    }

      constructor(w:Number, h:Number){
        this.width  = w;
        this.height = h;
        this.screen_list = Array<Screen_Model>();
    }


    //서버에서 읽어온 json정보로 셋팅
    setStringValue(params:string):void{
        
        //console.log("setStringValue : " + params);

        const temp          = JSON.parse(JSON.stringify(params));
        this.width          = temp.width;
        this.height         = temp.height;
        //console.log("setStringValue : " + temp.width);

        

        this.screen_list.splice(0, this.screen_list.length);
        temp.screen_list.forEach((screen:string) => {
            const sm = new Screen_Model();
            sm.setStringValue(screen);
            this.screen_list.push(sm);
        });
        
    }

}

export default Content_Model
